export const formatPhone = (raw: string) => {
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "");
  const part1 = digits.slice(0, 2);
  const part2 = digits.slice(2, 7);
  const part3 = digits.slice(7, 11);
  let formatted = "";
  if (part1) formatted += `(${part1})`;
  if (part2) formatted += `-${part2}`;
  if (part3) formatted += `-${part3}`;
  return formatted;
};

export default formatPhone;
